import { StaffApi } from 'helpers';

export const createDevContractTestCampaign = async (
  authToken: string,
  request: unknown
) => {
  const { data } = await new StaffApi('campaigns', authToken).post(
    'DevCreateContractTestCampaign',
    request
  );

  return data;
};
